import {
  useImportList as useImportListQuery,
  useImportGet as useImportGetQuery,
  type ImportJobSurfaceDto,
  type ImportJobsPageResponseDto,
} from '../../../api/generated/client';
import { ROUTE_IDS, OPERATION_IDS } from '@finance/contracts';
import type { ListHookResult, GetHookResult, ResourceHookBinding } from '../../resource-hook-registry.js';
import { selectApiData, type ApiSuccessEnvelope } from '../../../api/select-api-data.js';

function selectImportListRows(response: unknown): ImportJobSurfaceDto[] {
  const data = selectApiData(response as ApiSuccessEnvelope<ImportJobsPageResponseDto>);
  return data?.items ?? [];
}

function selectImportDetail(response: unknown): ImportJobSurfaceDto {
  return selectApiData(response as ApiSuccessEnvelope<ImportJobSurfaceDto>);
}

export function useImportList(): ListHookResult<ImportJobSurfaceDto[]> {
  return useImportListQuery({ query: { select: selectImportListRows } });
}

export function useImportGet(id: string): GetHookResult<ImportJobSurfaceDto> {
  return useImportGetQuery(id, { query: { select: selectImportDetail } });
}

export const IMPORT_JOBS_HOOKS: ResourceHookBinding<ImportJobSurfaceDto[], ImportJobSurfaceDto> = {
  useList: useImportList,
  selectList: selectImportListRows,
  useGet: useImportGet,
  selectDetail: selectImportDetail,
  rowIdExtractor: (row) => (typeof row.id === 'string' ? row.id : undefined),
  rowIdField: 'id',
  routeParameterName: 'id',
  paramName: 'id',
  listRouteId: ROUTE_IDS.DATA_IMPORTS,
  detailRouteId: ROUTE_IDS.DATA_IMPORT_DETAIL,
  readOperationId: OPERATION_IDS.IMPORT_GET,
  detailDescriptorId: 'detail.importJobs',
};
